import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=25afedcd&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "@/styles/_left_menu.scss?vue&type=style&index=0&id=25afedcd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25afedcd",
  null
  
)

export default component.exports